var map = {
	"./add.svg": "1ee7",
	"./add_box.svg": "d276c",
	"./add_circle.svg": "7fec",
	"./add_circle_outline.svg": "6eca",
	"./archive.svg": "2aa4",
	"./backspace.svg": "eb00",
	"./block.svg": "7008",
	"./clear.svg": "4e14",
	"./content_copy.svg": "c9ab",
	"./content_cut.svg": "923d",
	"./content_paste.svg": "e3b3",
	"./create.svg": "a8b5",
	"./delete_sweep.svg": "9985",
	"./drafts.svg": "be94",
	"./filter_list.svg": "5b6c",
	"./flag.svg": "a641",
	"./font_download.svg": "3921",
	"./forward.svg": "c5585",
	"./gesture.svg": "67d2",
	"./inbox.svg": "505a",
	"./link.svg": "ddbd",
	"./low_priority.svg": "2a76",
	"./mail.svg": "ab1d",
	"./markunread.svg": "f938",
	"./move_to_inbox.svg": "3dd8",
	"./next_week.svg": "cbfe",
	"./redo.svg": "74b0",
	"./remove.svg": "1390",
	"./remove_circle.svg": "6378",
	"./remove_circle_outline.svg": "e73e",
	"./reply.svg": "eba8",
	"./reply_all.svg": "1f5b",
	"./report.svg": "c622",
	"./save.svg": "3036",
	"./select_all.svg": "6e34",
	"./send.svg": "ac09",
	"./sort.svg": "8b8e",
	"./text_format.svg": "6149",
	"./unarchive.svg": "c767",
	"./undo.svg": "d271",
	"./weekend.svg": "8896"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "903c";